export default [
  {
    path: '/animation',
    component: () => import('./layouts/AnimationLayout'),
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        component: () => import('./containers/NoOpenSessionContainer'),
        children: [],
      },
      {
        path: 'session/:sessionId',
        name: 'AnimationSession',
        component: () => import('./layouts/SessionLayout'),
        props: true,
        children: [
          {
            path: 'players',
            component: () => import('./containers/PlayersContainer'),
            props: true,
            children: [],
          },
          {
            path: 'games/:gameName/:gameId',
            component: () => import('./containers/GameContainer'),
            props: true,
            children: [],
          },
        ],
      },
    ],
  },
]
